import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {ConfigurationService, JowLogin, LoginService} from '@irisims/justconsult-api';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class JustOnWebResolver  {
  constructor(private loginService: LoginService, private configService: ConfigurationService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const token = {} as JowLogin;
    token.ticketId = route.paramMap.get('id');
    return this.loginService.jow(token).pipe(catchError(
      err => {
        window.alert(err.message);
        return of(null);
      }
    ));
  }
}
